import { Grid } from '@mui/material';
import Input from '../../../components/Input/Input';
import { INTEGERS_UNIT } from '../../../constants/regex';
import { useTranslation } from 'react-i18next';
import AutocompleteComponent from '../../../components/layout/Autocomplete';
import useContracts from '../../../components/layout/ContractSelector/hook/useContracts';
import { CONVOCATED_STATUS_OPTIONS } from '../consts/convocatedTypes';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface ConvocatedFiltersProps {
    extraFilters: any;
    handleChangeExtraFilters: (e: any) => void;
}

const ConvocatedFilters = (props: ConvocatedFiltersProps) => {
    const { extraFilters, handleChangeExtraFilters } = props;
    const { contracts } = useContracts();

    const { t } = useTranslation('periodicos');

    const contractOptions = contracts.map((contract) => ({
        nombre: `${contract.nombre}`,
        id: contract.id,
        value: contract.nroContrato
    }));

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <Input
                        label={`${t('header.extraFilters.convocatedNro')}`}
                        size="small"
                        name="id"
                        onChange={handleChangeExtraFilters}
                        value={extraFilters?.id || ''}
                        clearable
                    />
                </Grid>

                <Grid item xs={3}>
                    <Input
                        label={`${t('header.extraFilters.cuit')}`}
                        size="small"
                        name="cuit"
                        onChange={(e: any) => {
                            const value = e.target.value;
                            if (
                                value === null ||
                                value === '' ||
                                (INTEGERS_UNIT.test(value) && value?.length <= 11)
                            ) {
                                handleChangeExtraFilters(e);
                            }
                        }}
                        value={extraFilters?.cuit || ''}
                        clearable
                    />
                </Grid>

                <Grid item xs={3}>
                    <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label={t('header.extraFilters.date')}
                            value={extraFilters?.fechaAlta ? dayjs(extraFilters.fechaAlta) : null}
                            format="DD/MM/YYYY"
                            onChange={(newValue) => {
                                const formattedDate = newValue
                                    ? dayjs(newValue).startOf('day').format('YYYY-MM-DDTHH:mm:ss')
                                    : '';
                                handleChangeExtraFilters({
                                    target: { name: 'fechaAlta', value: formattedDate }
                                });
                            }}
                            sx={{ width: '100%' }}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={3}>
                    <AutocompleteComponent
                        label={t('header.extraFilters.state')}
                        size="small"
                        name="estado"
                        onChange={(value: any) => {
                            handleChangeExtraFilters({
                                target: { name: 'estado', value: value?.id ?? '' }
                            });
                        }}
                        value={
                            CONVOCATED_STATUS_OPTIONS.find(
                                (option) => option.id === extraFilters?.estado
                            ) || null
                        }
                        options={CONVOCATED_STATUS_OPTIONS}
                        clearable
                    />
                </Grid>
            </Grid>
        </>
    );
};

export { ConvocatedFilters };
